import { render, staticRenderFns } from "./personalAreaAdministration.vue?vue&type=template&id=f8781972&"
import script from "./personalAreaAdministration.vue?vue&type=script&lang=js&"
export * from "./personalAreaAdministration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports